import Vue from "vue";
import Meta from "vue-meta";

Vue.use(Meta, {
  keyName: "metaInfo",
  attribute: "data-vue-meta",
  ssrAttribute: "data-vue-meta-server-rendered",
  tagIDKeyName: "vmid",
  refreshOnceOnNavigation: true,
});

// 공통 메타태그 설정
const commonMeta: any = {
  meta: [
    { charset: "utf-8" },
    { "http-equiv": "Content-Script-Type", content: "text/javascript" },
    { "http-equiv": "Content-Style-Type", content: "text/css" },
    { "http-equiv": "X-UA-Compatible", content: "IE=edge, Chrome=1" },
    { "http-equiv": "Cache-Control", content: "no-cache" },
    {
      "http-equiv": "Pragma",
      content:
        "no-store, must-revalidate, post-check=0, pre-check=0, max-age=0",
    },
    { "http-equiv": "Expires", content: "0" },
    {
      name: "viewport",
      content:
        "width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no",
    },
    { name: "author", content: process.env.VUE_APP_META_AUTHOR || "" },
    { name: "keywords", content: process.env.VUE_APP_META_KEYWORDS || "" },
    {
      name: "description",
      content: process.env.VUE_APP_META_DESCRIPTION || "",
    },
    { name: "theme-color", content: process.env.VUE_APP_THEME_COLOR || "" },
    { name: "application-name", content: process.env.VUE_APP_NAME || "" },
    {
      name: "apple-mobile-web-app-title",
      content: process.env.VUE_APP_NAME || "",
    },
    { name: "mobile-web-app-capable", content: "yes" },
    { name: "apple-mobile-web-app-capable", content: "yes" }, // 하위 호환성을 위해 유지
    {
      name: "naver-site-verification",
      content: "5ad49389601254aa6e5a6777b7f6267b5ac6c52e",
    },
    // Open Graph 기본값
    { property: "og:title", content: process.env.VUE_APP_NAME || "" },
    { property: "og:url", content: process.env.VUE_APP_ENDPOINT || "" },
    { property: "og:image", content: process.env.VUE_APP_META_IMAGE || "" },
    {
      property: "og:description",
      content: process.env.VUE_APP_META_DESCRIPTION || "",
    },
    // Twitter Card 기본값
    { name: "twitter:card", content: "summary" },
    { name: "twitter:title", content: process.env.VUE_APP_NAME || "" },
    { name: "twitter:url", content: process.env.VUE_APP_ENDPOINT || "" },
    {
      name: "twitter:image",
      content: `${process.env.VUE_APP_ENDPOINT || ""}/icons/icon-512x512.png`,
    },
    {
      name: "twitter:description",
      content: process.env.VUE_APP_META_DESCRIPTION || "",
    },
  ],
  title: process.env.VUE_APP_NAME || "",
  link: [{ rel: "canonical", href: process.env.VUE_APP_ENDPOINT || "" }],
};

// Vue 인스턴스에 공통 메타태그를 전역으로 설정
Vue.mixin({
  metaInfo(): any {
    return commonMeta;
  },
});

export default Meta;
